/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Community_TopicsInputs */

const en_community_topics = /** @type {(inputs: Community_TopicsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Community Topics`)
};

const es_community_topics = /** @type {(inputs: Community_TopicsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Temas de la Comunidad`)
};

const fr_community_topics = /** @type {(inputs: Community_TopicsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sujets de la communauté`)
};

const de_community_topics = /** @type {(inputs: Community_TopicsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Community-Themen`)
};

const id_community_topics = /** @type {(inputs: Community_TopicsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Topik Komunitas`)
};

/** @type {(inputs: Community_TopicsInputs) => LocalizedString} */
const ja_community_topics = en_community_topics;

/** @type {(inputs: Community_TopicsInputs) => LocalizedString} */
const zh_community_topics = en_community_topics;

/** @type {(inputs: Community_TopicsInputs) => LocalizedString} */
const ar_community_topics = en_community_topics;

/** @type {(inputs: Community_TopicsInputs) => LocalizedString} */
const it_community_topics = en_community_topics;

/** @type {(inputs: Community_TopicsInputs) => LocalizedString} */
const ru_community_topics = en_community_topics;

/** @type {(inputs: Community_TopicsInputs) => LocalizedString} */
const pt_community_topics = en_community_topics;

/** @type {(inputs: Community_TopicsInputs) => LocalizedString} */
const ko_community_topics = en_community_topics;

/**
* | output |
* | --- |
* | "Community Topics" |
*
* @param {Community_TopicsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const community_topics = /** @type {((inputs?: Community_TopicsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_TopicsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_community_topics(inputs)
	if (locale === "es") return es_community_topics(inputs)
	if (locale === "fr") return fr_community_topics(inputs)
	if (locale === "de") return de_community_topics(inputs)
	if (locale === "ja") return ja_community_topics(inputs)
	if (locale === "zh") return zh_community_topics(inputs)
	if (locale === "ar") return ar_community_topics(inputs)
	if (locale === "id") return id_community_topics(inputs)
	if (locale === "it") return it_community_topics(inputs)
	if (locale === "ru") return ru_community_topics(inputs)
	if (locale === "pt") return pt_community_topics(inputs)
	return ko_community_topics(inputs)
});